import { gql } from "@apollo/client";

export const VALIDATE_CONTRATO = gql`
    mutation ValidateEvaluacion(
        $idEvaluacion: Int!,
    ){
        validateEvaluacion(
            idEvaluacion: $idEvaluacion,
        ) 
    }
`;